import { ObjectFieldTemplateProps } from '@rjsf/utils';

/**
 * Custom ObjectFieldTemplate that supports a grid layout via ui:options.grid
 * Example usage in uiSchema:
 * "ui:options": {
 *   "grid": 2 // 2 columns
 * }
 */
export function GridObjectFieldTemplate(props: ObjectFieldTemplateProps) {
  const { title, description, properties, uiSchema, registry } = props;

  // Early return if no properties
  if (!properties || !Array.isArray(properties)) {
    return null;
  }

  const gridCols = uiSchema?.['ui:options']?.grid || uiSchema?.['ui:grid'];
  const gap = uiSchema?.['ui:options']?.gap || 2;

  // Calculate grid style based on columns
  const gridStyle = gridCols
    ? {
        display: 'grid',
        gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))`,
        gap: `${gap * 0.25}rem`,
      }
    : undefined;

  // Get templates from registry
  const TitleFieldTemplate = registry?.templates?.TitleFieldTemplate;
  const DescriptionFieldTemplate = registry?.templates?.DescriptionFieldTemplate;

  // Generate unique ID for title/description
  const baseId = typeof title === 'string' ? title.toLowerCase().replace(/\s+/g, '-') : 'object';

  return (
    <div>
      {title && TitleFieldTemplate && (
        <TitleFieldTemplate
          id={`${baseId}-title`}
          title={title}
          required={props.required}
          schema={props.schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      {description && DescriptionFieldTemplate && (
        <DescriptionFieldTemplate
          id={`${baseId}-description`}
          description={description}
          schema={props.schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      <div className={!gridCols ? 'space-y-2' : undefined} style={gridStyle}>
        {properties.map((element, index) => (
          <div key={element.name || `property-${index}`} className="w-full">
            {element.content}
          </div>
        ))}
      </div>
    </div>
  );
}
